import React from 'react'
import { string } from 'prop-types'

import NotInstallableButton from './NotInstallableButton'

const DefaultCase = (props) => (
  <NotInstallableButton {...props}>
    <span>You cannot install this app.</span>
  </NotInstallableButton>
)

DefaultCase.propTypes = {
  id: string,
}

export default DefaultCase
